var React = require('react');

function Inventory (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"none","key":0}),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M20,2H4C3,2,2,2.9,2,4v3.01C2,7.73,2.43,8.35,3,8.7V20c0,1.1,1.1,2,2,2h14c0.9,0,2-0.9,2-2V8.7c0.57-0.35,1-0.97,1-1.69V4 C22,2.9,21,2,20,2z M19,20H5V9h14V20z M20,7H4V4h16V7z","key":0}),React.createElement("rect",{"height":"2","width":"6","x":"9","y":"12","key":1})])]);
}

Inventory.defaultProps = {"enableBackground":"new 0 0 24 24","viewBox":"0 0 24 24"};

module.exports = Inventory;

Inventory.default = Inventory;
